<template>
  <Home :isAdminPage="false" />
</template>

<script>
import Home from './home';
import qidianMixin from '@/mixins/qidian'

export default {
  mixins: [qidianMixin],
  name: "QiDianAdmin",
  components: {
    Home
  },
  data() {
    return {

    };
  },
  created() {
    if(this.$route.query.scene === 'client') {
      // 创建企点客户端通信通道
      window.qidianClientChannel = new BroadcastChannel('qidian-client-channel');
      window.qidianClientChannel.addEventListener('message', event => {
        if(event && event.data && event.data.method === 'openTopMenu') {
          this.topPostMsg('openTopMenu')
        } else {
          this.postMsgListener(event)
        }
      });
    }
  },
  mounted() {

  },
  beforeDestroy() {
    if(window.qidianClientChannel) {
      window.qidianClientChannel.close();
    }
  },
  computed: {

  },
  methods: {

  }
};
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/view/QiDian/Agent.vue